module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('component-header'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('component-footer')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('h5', [_vm._v("Pending Activation....")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03aa5a7c"}!./src/pages/Adminpoint/Orders/template.html
// module id = 272
// module chunks = 0